import React from "react";

interface BodyContentProps {
  children: React.ReactNode;
}

export const BodyContent: React.FC<BodyContentProps> = ({
  children,
}: BodyContentProps) => {
  return (
    <div className="body__content-container">
      <div className="body__content">{children}</div>
    </div>
  );
};
